import React, { useState } from "react";
import { InstantSearch, SearchBox, Hits } from "react-instantsearch-hooks-web";
import { NavLink } from "react-router-dom";
import { useStateValue } from "../../context/StateProvider";
import {
  buttonClick,
  fadeInOut,
  imageWhileHover,
} from "../../utils/animations";
import algoliasearch from "algoliasearch";
import { motion } from "framer-motion";
import {
  FaAlgolia,
  FaDownload,
  FaGlobeAsia,
  IoClose,
} from "../../assets/icons";
import moment from "moment";
import { Nodata } from "../../assets";

const Search = ({ setIsFocused }) => {
  const searchClient = algoliasearch(
    // process.env.REACT_APP_ALGOLIA_ID,
    // process.env.REACT_APP_ALGOLIA_KEY
    "E1ROWD9KOB",
    "284dac78263e96d4e608701416d3444b"
  );

  const clientIndex = searchClient.initIndex("concepts");
  return (
    <motion.div
      {...fadeInOut}
      className="fixed z-50 inset-0  bg-darkOverlay backdrop-blur-md flex items-center justify-center p-4 "
    >
      <div className="relative  w-full h-full md:w-656 md:h-510 bg-white rounded-md shadow-md p-6 pt-12 flex flex-col overflow-hidden items-center justify-center">
        <motion.div
          onClick={() => setIsFocused(false)}
          className="absolute top-2 right-2 cursor-pointer w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center"
        >
          <IoClose className=" -rotate-0 text-white text-2xl" />
        </motion.div>

        <div className=" flex items-center absolute top-2 left-6 gap-2 ">
          <p className="text-base text-textColor">Search By: </p>
          <div className=" flex items-center gap-1">
            <FaAlgolia className="-rotate-0 text-lg text-blue-500" />
            <p className="text-base text-textColor">algolia</p>
          </div>
        </div>

        <InstantSearch searchClient={searchClient} indexName="concepts">
          <SearchBox
            placeholder="seach here...!"
            className=" w-full px-4 py-1 bg-primary rounded-md shadow-md"
          />
          <div className=" w-full mt-4 flex flex-col overflow-y-scroll scrollbar-thin scrollbar-thumb-primary   gap-3">
            <Hits hitComponent={Hit} />
          </div>
        </InstantSearch>
      </div>
    </motion.div>
  );
};

export const Hit = ({ hit }) => {
  const [{ user }, dispatch] = useStateValue();

  if (!hit) {
    return (
      <div className="w-full flex items-center justify-center ">
        <img src={Nodata} className=" w-3" alt="" />
      </div>
    );
  }
  if (hit.concept_id) {
    return (
      <NavLink
        to={`/videoDetail/${hit.concept_id}`}
        className=" w-full flex items-start justify-start py-2 cursor-pointer gap-3 hover:shadow-md hover:bg-primary rounded-md border border-gray-200 my-1"
      >
        <motion.div className="w-32 rounded-md  bg-slate-100 overflow-hidden flex items-center justify-center">
          <motion.img
            {...imageWhileHover}
            src={hit?.video_thumb}
            alt=""
            className="w-full h-20 object-cover rounded-md"
          />
        </motion.div>

        <div className=" w-full flex flex-col gap-2">
          <p className="text-textColor text-lg font-semibold ">
            {hit.video_name}
          </p>
          <div className=" flex justify-items-center gap-6">
            {user && (
              <>
                {hit?.liveURL.length > 0 && (
                  <a href={hit?.liveURL} target="_blank">
                    <motion.button
                      {...buttonClick}
                      className="px-4 py-1 flex items-center justify-center gap-3 rounded-md border-none   outline-none cursor-pointer hover:shadow-md text-textColor"
                    >
                      <FaGlobeAsia className=" -rotate-0 text-textColor" />
                    </motion.button>
                  </a>
                )}

                {hit?.github.length > 0 && (
                  <a href={hit?.github} target="_blank">
                    <motion.button
                      {...buttonClick}
                      className="px-4 py-1 flex items-center justify-center gap-3 rounded-md  border-none  outline-none cursor-pointer hover:shadow-md text-textColor"
                    >
                      <FaDownload className=" -rotate-0 text-textColor" />
                    </motion.button>
                  </a>
                )}
              </>
            )}
            <p className="text-base text-slate-600">
              {moment(
                new Date(parseInt(hit.concept_id)).toISOString()
              ).fromNow()}
            </p>
          </div>
        </div>
      </NavLink>
    );
  }
};

export default Search;
